import { NgModule } from '@angular/core';
import { MspTableComponent } from './msp-table.component';

@NgModule({
	declarations: [],
	imports: [MspTableComponent],
	exports: [MspTableComponent],
})
export class MspTableModule {}
